<template>
	<div class="d-flex flex-column flex h100">
		<navbar></navbar>
		<div class="app">
			<div id="content" class="app-content box-shadow-3 scroll-x">
				<!-- Optional navbar at top of page -->
				<div class="navbar navbar-light bg-white b-b">
					<a class="navbar-brand flex">
						<span v-if="!loading">My Classes</span>
						<span v-if="loading">
							<loading type="inline-header" />
						</span>
					</a>
					<button class="btn theme text-white mr-3" @click="showEditClass()">
						<i class="fas fa-plus mr-1" />
						Add Class
					</button>
					<a class="btn-nav-topright b-l ml-0" href="/#/landing">
						<div>
							<i class="fas fa-th-large fa-fw" />
							Home
						</div>
					</a>
				</div>

				<div class="content-main">
					<div class="padding text-center h-100 d-flex flex-column justify-content-center" v-if="!loading">
						<div class="col-12 p-0 flex scroll-y">
							<div class="p-3">
								<div
									v-if="!classes.length"
									class="box card section m-auto no-assignments justify-self-start"
								>
									<div class="box-header theme lighten-3">No Classes</div>
									<div class="box-body light lt text-center p-4">
										<p class="m-0">
											You are not assigned to any classes. Use the "Add Class" button above to add
											a new class.
										</p>
									</div>
								</div>

								<div v-if="classes.length" class="row">
									<div
										v-for="(classObj, i) in classes"
										:key="i"
										v-if="classObj.user_id != user.id"
										class="col-12 col-sm-6 col-xl-4"
									>
										<div class="box clickable d-flex flex-column" @click="goToClass(classObj)">
											<div class="d-flex flex-row align-items-center justify-content-between">
												<div class="align-self-stretch">
													<div class="h-100 d-flex flex-column align-items-start">
														<h5
															class="no-grow _600 theme-lighten-2 text-white py-2 px-3 curved-br"
														>
															{{ classObj.name }}
														</h5>
														<div class="flex"></div>
														<div v-if="classObj.ref_id != ''" class="no-grow text-xs text-muted pl-2 pb-2">
															{{ classObj.ref_id }}
														</div>
														<div v-if="classObj.ref_id == ''" class="no-grow text-xs text-muted pl-2 pb-2">
															{{ classObj.course_number }}
														</div>
													</div>
												</div>
												<div class="px-3">
													<h3 class="text-center w65 mb-0">
														{{ classObj.student_ids.length }}
													</h3>
													<div class="text-center text-muted">Students</div>
												</div>
												<div></div>
											</div>

											<hr class="w-100 mt-2" />

											<div style="text-align: left;">
												<ul
													class="mb-0"
													v-if="classObj.deliveries && classObj.deliveries.length"
												>
													<strong>Assessments:</strong>
													<li v-for="deliv in classObj.deliveries" :key="deliv.id">
														{{ deliv.name }}
													</li>
												</ul>
												<span
													v-if="!classObj.deliveries || !classObj.deliveries.length"
													class="text-muted"
													style="padding-left: 40px;"
													>No assessments</span
												>
											</div>

											<div class="d-flex flex-row align-items-center px-4 py-3">
												<div class="flex text-left">
													<i
														v-if="classObj.team_id"
														class="fas fa-hands-helping fa-fw"
														v-tippy
														:title="cstTooltip(classObj.team_name)"
													/>
												</div>
												<a
													class="btn btn-sm btn-icon btn-rounded danger text-white mr-1"
													@click.stop="showDeleteClass(classObj)"
													v-tippy
													title="Delete"
												>
													<i class="fas fa-trash" />
												</a>
												<a
													class="btn btn-sm btn-icon btn-rounded theme text-white mr-1"
													@click.stop="showEditClass(classObj)"
													v-tippy
													title="Edit"
												>
													<i class="fas fa-edit" />
												</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="modal" id="noSchoolsModal" data-backdrop="static" data-keyboard="false">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="mb-0">Cannot Create Class</h5>
					</div>
					<div class="modal-body">
						<div class="row p-4 text-md">
							No classes can be created because no schools exist in the system. Please contact your
							administrator.
						</div>
					</div>
					<div class="modal-footer">
						<button class="btn btn-flat btn-primary" data-dismiss="modal">Okay</button>
					</div>
				</div>
			</div>
		</div>

		<div class="modal" id="editClassModal" data-backdrop="static" data-keyboard="false">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="mb-0">{{ editClassTitle }}</h5>
					</div>
					<div class="modal-body">
						<form role="form" class>
							<div class="form-group">
								<label>Class Name</label>
								<input type="text" v-model="editClass.name" class="form-control" />
							</div>
							<div class="form-group">
								<label>Class Code</label>
								<input type="text" v-model="editClass.ref_id" class="form-control" />
							</div>
							<div class="form-group">
								<label>School</label>
								<v-select :options="schools" v-model="editClassSchool" label="name">
									<template slot="selected-option" slot-scope="option">
										<span>
											{{ option.name }}
											<span v-if="option.building_ref_id">
												•
												<span class="text-muted text-sm">({{ option.building_ref_id }})</span>
											</span>
										</span>
									</template>

									<template slot="option" slot-scope="option">
										<span>
											{{ option.name }}
											<span v-if="option.building_ref_id">
												•
												<span class="text-muted text-sm">({{ option.building_ref_id }})</span>
											</span>
										</span>
									</template>
								</v-select>
							</div>
						</form>
					</div>
					<div class="modal-footer">
						<button class="btn btn-flat" data-dismiss="modal">Cancel</button>
						<button class="btn btn-flat theme" data-dismiss="modal" @click="saveClass(editClass)">
							Save
						</button>
					</div>
				</div>
			</div>
		</div>

		<div class="modal" id="deleteClassModal" data-backdrop="static" data-keyboard="false">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="mb-0">Delete Class</h5>
					</div>
					<div class="modal-body">
						<div class="row px-4 py-2 text-md">
							<h5 class="py-2">
								Are you sure you want to delete the class
								<br />
								<strong class="text-theme text-center">"{{ deleting.name }}"</strong>?
							</h5>
							<h6 class="py-2">
								<span class="text-danger far faw fa-exclamation-triangle"></span>
								The operation will occur immediately, cannot be canceled or reversed, and will
								permanently delete all student work and scores in this class!
							</h6>
						</div>
						<div class="form-group pl-2 pr-3">
							<input type="text" v-model="deleteConfirm" class="form-control" />
							<small class="text-muted">To confirm, type the name of the class</small>
						</div>
					</div>
					<div class="modal-footer">
						<button class="btn btn-flat" data-dismiss="modal">Cancel</button>
						<button
							class="btn btn-flat"
							:class="{ [deleting.name != deleteConfirm ? 'btn-secondary' : 'btn-danger']: true }"
							data-dismiss="modal"
							@click="deleteClass(deleting)"
							:disabled="deleting.name != deleteConfirm"
						>
							Delete
						</button>
					</div>
				</div>
			</div>
		</div>

		<mzfooter></mzfooter>
	</div>
</template>

<style scoped>
.curved-br {
	border-bottom-right-radius: 0.75rem;
}
.section {
	max-width: 500px;
}
.section > .box-header {
	text-align: center;
	font-size: 28px;
}
.btn-icon.btn-sm {
	width: 2rem;
	height: 2rem;
	line-height: 2rem;
}
.clickable {
	cursor: pointer;
	transition: background-color 0.1s ease-in-out;
}
.clickable:hover {
	background-color: rgb(0, 0, 0, 0.1);
}
</style>

<script>
import ClassService from "@/services/ClassService";
import SchoolService from "@/services/SchoolService";
import Notie from "@/services/NotieService";
import BB from "bluebird";
import $ from "jquery";
import fs from "@/services/FormatService";

export default {
	name: "Classes",

	props: ["user"],

	data() {
		return {
			classes: [],
			schools: [],

			editClassTitle: "",
			editClass: {},
			editClassSchool: null,

			deleting: {},
			deleteConfirm: null,

			loading: true
		};
	},

	components: {},

	created() {
		this.loadData();
	},

	watch: {
		    		"editClass.name"() {
			if (this.autoRef) {
				this.editClass.ref_id = this.generateAutoRef(this.editClass.name);
			}
		},
		"editClass.ref_id"() {
			this.checkAutoRef();
		},
		editClassSchool(newVal) {
			if (newVal) {
				this.editClass.school_id = newVal.id;
			} else {
				this.editClass.school_id = null;
			}
		}
	},

	methods: {
		loadData() {
			return BB.props({
				classes: ClassService.getMyClasses(),
				schools: SchoolService.listSchools({
					district_id: this.user.district_id
				})
			})
				.then(resps => {
					this.classes = resps.classes.data.classes;
					this.schools = resps.schools.data.schools;
					this.loading = false;
				})
				.catch(err => {
					console.log(err);
					Notie.error("Failed to load classes", err);
				});
		},

		blankNewClass() {
			this.editClass = {
				name: "New Class",
				ref_id: "new_class",
				school_id: this.schools[0].id,
				district_id: this.user.district_id,
				owner_ids: [this.user.id]
			};
			this.editClassSchool = this.schools[0];
		},

		showEditClass(classObj) {
			if (!this.schools || !this.schools.length) {
				$("#noSchoolsModal").modal();
				return;
			}

			if (!classObj) {
				this.editClassTitle = "Add Class";
				this.blankNewClass();
			} else {
				this.editClassTitle = "Edit Class";
				this.editClass = classObj;
				this.editClassSchool = _.find(this.schools, {
					id: this.editClass.school_id
				});
			}
			$("#editClassModal").modal();
		},

		showDeleteClass(classObj) {
			this.deleting = classObj;
			this.deleteConfirm = "";
			$("#deleteClassModal").modal();
		},

		saveClass(classObj) {
			return ClassService.saveClass(classObj)
				.then(resp => {
					this.loadData();
				})
				.catch(err => {
					console.log(err);
					Notie.error("Failed to save class", err);
				});
		},

		deleteClass(classObj) {
			return ClassService.removeClass(classObj.id)
				.then(resp => {
					this.loadData();
					Notie.info(`${classObj.name} deleted`);
				})
				.catch(err => {
					console.log(err);
					Notie.error("Failed to delete class", err);
				});
		},

		goToClass(classObj) {
			this.$router.push(`/class/${classObj.id}`);
		},
		checkAutoRef() {
			let genRef = this.generateAutoRef(this.editClass.name);
			this.autoRef = this.editClass.ref_id == genRef;
    },
    generateAutoRef(name) {
			return name && fs.toGoodRefID(name);
		},
		cstTooltip(teamName) {
			return `<div class="text-left"><div class="text-xxs text-muted">Collaborative Scoring Team</div><div>${teamName}</div></div>`;
		}
	}
};
</script>





// WEBPACK FOOTER //
// src/vues/Classes/Classes.vue